import { render } from "./MaintenancesList.vue?vue&type=template&id=2e628de9"
import script from "./MaintenancesList.vue?vue&type=script&lang=js"
export * from "./MaintenancesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__